import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import AdminDemos from "@/pages/AdminDemos";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/demos" element={<AdminDemos />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
